var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgHidePassword = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "hide password@4x")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Landowners",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landowner-sign-in",
    transform: "translate(-1087.000000, -571.000000)",
    fill: "#4A5569"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24pt/ic_eye_off",
    transform: "translate(1085.000000, 569.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_eye_off",
    fill: "none",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    fill: "#000000",
    opacity: 0,
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.41666666,2.25 L7.56539166,6.398725 C7.63071185,6.45016833 7.69280903,6.51184462 7.75,6.58333334 L10.5664007,9.39973402 C10.6620026,9.44136133 10.7525611,9.50256111 10.8333333,9.58333334 C10.9141056,9.66410558 10.9753053,9.75466404 11.0169327,9.850266 L14.0664007,12.899734 C14.1620026,12.9413613 14.2525611,13.0025611 14.3333333,13.0833333 C14.4141056,13.1641056 14.4753053,13.254664 14.5169327,13.350266 L17.4510905,16.2844239 C17.5013018,16.3227539 17.5460286,16.366927 17.5833333,16.4166667 L21.75,20.5833333 C22.0833333,20.9166667 22.0833333,21.4166667 21.75,21.75 C21.5833333,21.9166667 21.4166667,22 21.1666667,22 C20.9166667,22 20.75,21.9166667 20.5833333,21.75 L16.8486635,18.0153302 C15.4469525,18.9863225 13.7555811,19.5 12,19.5 C5.75,19.5 2.25,12.6666667 2.08333334,12.3333333 C2,12.0833333 2,11.8333333 2.08333334,11.5833333 C3.0217157,9.85093511 4.27272345,8.30611211 5.83635659,7.00302349 L2.25,3.41666666 C1.91666666,3.08333334 1.91666666,2.58333334 2.25,2.25 C2.58333334,1.91666666 3.08333334,1.91666666 3.41666666,2.25 Z M7.02017901,8.18684567 C5.69959337,9.26501917 4.62835766,10.5360706 3.75,12 C4.5,13.3333333 7.5,17.8333333 12,17.8333333 C13.2673074,17.8333333 14.5346147,17.4596222 15.6309963,16.7976629 L13.6672933,14.83396 C13.1808349,15.1589487 12.6087959,15.3613216 12,15.4166667 C12,15.5 12,15.4166667 11.9166667,15.4166667 C11.0833333,15.4166667 10.25,15.0833333 9.66666666,14.5 C9,13.9166667 8.66666666,13.0833333 8.58333334,12.1666667 C8.58333334,11.4696776 8.72786702,10.8208664 9.09019865,10.2568653 L7.02017901,8.18684567 Z M12,4.5 C18.25,4.5 21.75,11.3333333 21.9166667,11.6666667 C22,11.9166667 22,12.1666667 21.9166667,12.4166667 C21.4166667,13.4166667 20.75,14.3333333 20,15.25 C19.8333333,15.4166667 19.5833333,15.5 19.3333333,15.5 C19.1666667,15.5 18.9166667,15.4166667 18.8333333,15.3333333 C18.5,15 18.4166667,14.5 18.75,14.1666667 C19.3333333,13.5 19.8333333,12.8333333 20.25,12.0833333 C19.5,10.75 16.5,6.25 12,6.25 C11.5,6.25 10.9166667,6.33333334 10.4166667,6.41666666 C10,6.41666666 9.58333332,6.16666666 9.41666666,5.75 C9.33333332,5.25 9.58333332,4.83333334 10.0833333,4.75 C10.6666667,4.58333334 11.3333333,4.5 12,4.5 Z M10.3461169,11.5127835 C10.306471,11.6717951 10.3005128,11.8358975 10.3333333,12 C10.3333333,12.4166667 10.5,12.8333333 10.8333333,13.1666667 C11.1666667,13.5 11.5833333,13.6666667 12,13.5833333 C12.1247044,13.5833333 12.2494089,13.5684042 12.3718792,13.5385459 L10.3461169,11.5127835 Z",
    id: "Fill",
    fill: "#9393AA"
  })))))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHidePassword, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/hide-password.e84a3e99.svg";
export { ForwardRef as ReactComponent };